export const ANIMATION_COEF = 1;
